export default __webpack_public_path__ + "assets/media/language.f91499d3.png";